import { createContext, useContext, useState, type ReactNode } from 'react'

interface CreateModalContextValue {
  open: boolean
  openCreateModal: () => void
  closeCreateModal: () => void
}

const CreateModalContext = createContext<CreateModalContextValue | null>(null)

export function CreateModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)

  return (
    <CreateModalContext.Provider
      value={{
        open,
        openCreateModal: () => setOpen(true),
        closeCreateModal: () => setOpen(false),
      }}
    >
      {children}
    </CreateModalContext.Provider>
  )
}

export function useCreateModal(): CreateModalContextValue {
  const ctx = useContext(CreateModalContext)
  if (!ctx) throw new Error('useCreateModal must be used within CreateModalProvider')
  return ctx
}
